import { Engine } from "json-rules-engine";

const ANNUAL_REVIEW_STARTED_MILESTONE_ID = "100299";

interface IAnnualReviewMilestoneCompletedParams {
  id?: string | number;
}

export function registerAnnualReviewFacts(engine: Engine): void {
  engine.addFact(
    "annualReviewMilestoneCompleted",
    async (params: IAnnualReviewMilestoneCompletedParams = {}, almanac) => {
      const milestones = (await almanac.factValue("milestones")) as
        | Record<string, { completed?: boolean; completedDate?: string }>
        | undefined
        | null;

      const milestoneId = params.id != null ? String(params.id).trim() : "";
      if (!milestoneId) return false;

      const milestone = milestones?.[milestoneId];
      if (!milestone?.completed || !milestone.completedDate) return false;

      const started = milestones?.[ANNUAL_REVIEW_STARTED_MILESTONE_ID];
      if (!started?.completed || !started.completedDate) return false;

      const milestoneTime = new Date(milestone.completedDate).getTime();
      const startedTime = new Date(started.completedDate).getTime();
      if (Number.isNaN(milestoneTime) || Number.isNaN(startedTime)) {
        return false;
      }

      return milestoneTime > startedTime;
    },
    { cache: false }
  );
}
